




import {Vue, Component} from 'vue-property-decorator'
import CreateBroadcast from '@/components/CreateBroadcast.vue'

@Component({
  components: {
      CreateBroadcast
  }
})
export default class BroadcastSentView extends Vue {
}
